export default "__VITE_ASSET__DU_K_AIr__"